import { type AssetDropDestination, type VideoRejectionReason } from './canvasAssetDropTypes';

function getVideoLimitDetail(rejections: VideoRejectionReason[]): string {
  if (rejections.length === 0) {
    return '';
  }

  const hasSize = rejections.some((r) => r === 'size' || r === 'both');
  const hasDuration = rejections.some((r) => r === 'duration' || r === 'both');
  const hasUnknown = rejections.some((r) => r === 'unknown');

  if (hasUnknown && !hasSize && !hasDuration) {
    return 'exceeds size or duration limit';
  }

  const parts: string[] = [];

  if (hasSize) {
    parts.push('exceeds 500MB');
  }
  if (hasDuration) {
    parts.push('exceeds 30s');
  }

  return parts.join(' and ');
}

/**
 * Builds the toast message for asset drop, matching selection bar copy.
 * Single message combines success, unsupported, and/or video-limit-exceeded counts.
 */
export function getAssetDropToastMessage(
  addedCount: number,
  unsupportedCount: number,
  destination: AssetDropDestination,
  videoRejections: VideoRejectionReason[] = [],
): string {
  if (addedCount <= 0 && unsupportedCount <= 0 && videoRejections.length <= 0) {
    return '';
  }

  const destinationLabel = destination === 'canvas' ? 'canvas' : 'chat';
  const addedText =
    addedCount > 0 ? `${addedCount} ${addedCount === 1 ? 'item' : 'items'} added to ${destinationLabel}` : '';
  const unsupportedText =
    unsupportedCount > 0
      ? `${unsupportedCount} ${unsupportedCount === 1 ? 'item' : 'items'} couldn't be added (unsupported type)`
      : '';
  const videoLimitText =
    videoRejections.length > 0
      ? `${videoRejections.length} ${videoRejections.length === 1 ? 'video' : 'videos'} couldn't be added (${getVideoLimitDetail(videoRejections)})`
      : '';

  return [addedText, unsupportedText, videoLimitText].filter(Boolean).join('. ');
}
